import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Checkbox, FormControlLabel, Autocomplete } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import YesNoDialog from '../YesNoDialog';
import { useNavigate, useParams } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import moment from 'moment-timezone';
import '../App.css';

const Event = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [useAmd, setUseAmd] = useState(false);
  const [messageText, setMessageText] = useState('');
  const [timezone, setTimezone] = useState('');
  const [site, setSite] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [openConfirmDeleteDialog, setOpenConfirmDeleteDialog] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const onFetchSuccess = (site) => {
      setSite(site);
      setName(site.name);
      setPhone(site.phone);
      setUseAmd(site.useAmd);
      setMessageText(site.dial1Text);
      setTimezone(site.timezone);
    };

    const fetchSite = async (id) => {
      const params = {
        _id: id,
      };
      rpc({
        method: 'GetSite',
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: onFetchSuccess
      });
    };
    if (id) {
      fetchSite(id);
    }
  }, [id]);

  const onSuccess = () => {
    navigate('/sites');
  };

  const createSite = async () => {
    if (name === '' || timezone === '') {
      setErrorMessage('Name and Timezone fields are required');
      setOpenErrorDialog(true);
      return;
    }
    const params = {
      name,
      phone,
      useAmd,
      dial1Text: messageText,
      timezone,
    };
    rpc({
      method: 'CreateSite',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess
    });
  };

  const updateSite = async () => {
    if (name === '' || timezone === '') {
      setErrorMessage('Name and Timezone fields are required');
      setOpenErrorDialog(true);
      return;
    }
    const params = {
      _id: id,
      name,
      phone,
      useAmd,
      dial1Text: messageText,
      timezone,
    };
    rpc({
      method: 'UpdateSite',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess
    });
  };

  const deleteSite = async () => {
    setOpenConfirmDeleteDialog(false);
    const params = {
      _id: id,
    };
    rpc({
      method: 'DeleteSite',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess
    });
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const handleCheckboxChange = (event) => {
    setUseAmd(event.target.checked);
  };

  const getButtons = () => {
    if (id) {
      return (
        <div className="HorizontalContainer">
          <Button className="Button" variant="contained" color="primary" onClick={updateSite}>
            Update
          </Button>
          <Button className="Button" variant="contained" color="primary" 
            onClick={() => {setOpenConfirmDeleteDialog(true);}}>
            Delete
          </Button>
        </div>
      );
    } else {
      return (
        <Button className="Button" variant="contained" color="primary" onClick={createSite}>
          Create
        </Button>
      );
    }
  };

  const getTimezoneOptions = () => {
    let options = [""];
    moment.tz.names().forEach((name) => {
      options.push(name);
    });
    return options;
  };

  return (
    <div className="SiteDetails">
      <Typography variant="h6" gutterBottom>
        Site {site !== null ? `${site.name}` : ''}
      </Typography>
      <TextField className="TextField"
        label="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <TextField className="TextField"
        label="Phone"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      />
      <FormControlLabel
        control={<Checkbox checked={useAmd} onChange={handleCheckboxChange} />}
        label="Use AMD"
      />
      <TextField className="TextField"
        label="Message Text"
        value={messageText}
        onChange={(e) => setMessageText(e.target.value)}
      />
      <Autocomplete className="Autocomplete"
        value={timezone}
        options={getTimezoneOptions()}
        onChange={(e, value) => setTimezone(value)}
        renderInput={(params) => <TextField {...params} label="Timezone" variant="outlined" />}
      />
      {getButtons()}
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
      <YesNoDialog open={openConfirmDeleteDialog} 
        onErrorDialogClose={() => {setOpenConfirmDeleteDialog(false);}}
        onYes={deleteSite} 
        title="Delete Site"
        message="Are you sure you want to delete the site? This action cannot be undone!"
      />
    </div>
  );
};

export default Event;
